import { Link, useLocation } from 'react-router-dom';
import { SidebarIcon, SidebarNavLinks } from '../../../helpers/helperFunctions';
import { colors } from '../../../styles/GlobalStyles';
import { Icon } from '../../../styles/Icons';
import { FlexCenter } from '../../../styles/stylesStyled';

import { AnimatePresence } from 'framer-motion';
import { SideButtons } from '../BackofficeLayoutStyled';
import { ShowHide } from './ShowHide';
import { P2 } from '../../../styles/FontStyles';

export const Sidebar = () => {
  const location = useLocation().pathname;

  return (
    <AnimatePresence exitBeforeEnter>
      {ShowHide() && (
        <SideButtons
          key='SideButtons'
          initial={{ transform: 'translateX(-72px)' }}
          animate={{ transform: 'translateX(0px)' }}
          exit={{ transform: 'translateX(-72px)' }}
          transition={{
            duration: 0.2
          }}>
          {SidebarNavLinks().map(({ link, disabled, name, hidden }, i) => {
            if (hidden) return null;

            return (
              <Link
                to={link}
                key={i}
                style={{
                  pointerEvents: disabled ? 'none' : 'auto'
                }}>
                <FlexCenter
                  style={{
                    opacity: disabled ? 0.3 : 1,
                    marginTop:
                      link === '/backoffice/flipme-cards' ||
                      link === '/backoffice/my-team'
                        ? 12
                        : 0,
                    marginBottom:
                      link === '/backoffice/flipme-cards' ||
                      link === '/backoffice/my-team'
                        ? 12
                        : 0
                  }}>
                  <Icon
                    m='15px 20px'
                    w='32px'
                    color={
                      location.startsWith(link)
                        ? colors.primary900
                        : colors.neutral900
                    }>
                    <SidebarIcon link={name} />
                  </Icon>
                  <P2
                    style={{ flex: 'none' }}
                    semiBold
                    color={
                      location.startsWith(link)
                        ? colors.primary900
                        : colors.neutral900
                    }>
                    {name}
                  </P2>
                </FlexCenter>
              </Link>
            );
          })}
        </SideButtons>
      )}
    </AnimatePresence>
  );
};
